import axios from "axios";
import { getGuestId } from "../utils/guest";

// const base_url = "http://localhost:30088/api";
const base_url = "https://makkliapi.dealdrivetechnology.com/api";

export const apiClient = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to every request if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("user_token");
    const guestId = getGuestId();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } 
    config.headers["x-guest-id"] = guestId;

    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Register Admin
export const loginAdmin = async (email, password) => {
  try {
    const payload = { email, password };
    const response = await apiClient.post("/sisi/auth/login", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const getUserCount = async () => {
  const res = await apiClient.get("/sisi/users");
  return res.data; // { count: 0 }
};

// Get total users
export const getAllUsers = async ({page = 1, limit = 20, role}) => {
  try {
     const res = await apiClient.get("/sisi/users", {params: {page, limit, role}});
  return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};


export const createFaq = (data) => {
  try {
  const res = apiClient.post("/sisi/faqs", data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to create faqs:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getFaqs = async () => {
  try {
  const res = await apiClient.get("/sisi/faqs");
  return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch faqs:",
      error.response?.data || error.message
    );
    throw error;
  }
};
export const updateFaq = (id, data) => {
  try {
  const res = apiClient.put(`/sisi/faqs/${id}`, data);
  return res.data;
  } catch (error) {
    console.log(
      "Failed to update faq:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteFaq = async (id) => {
  try {
    const res = await apiClient.delete(`/sisi/faqs/${id}`);
    return res.data;
  } catch (error) {
    console.error(
      "Failed to delete FAQ:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createHero = async (data) => {
  try {
  const res = await apiClient.post("/sisi/hero", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getHero = async () => {
  try {
  const res = await apiClient.get("/sisi/hero");
  return res.data;
} catch (error) {
    console.log(
      "Failed to fetch hero section:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateHero = async (data) => {
  try {
  const res = await apiClient.put(`/sisi/hero`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to update hero:",
      error.response?.data || error.message
    );
    throw error;
  }
};


export const createSiteSettings = async (data) => {
  try {
  const res = await apiClient.post("/sisi/settings", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getSiteSettings = async () => {
  try {
  const res = await apiClient.get("/sisi/settings");
  return res.data;
} catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateSiteSettings  = async (data) => {
  try {
  const res = await apiClient.put(`/sisi/settings`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};


export const fetchCart = async () => {
  try {
    const res = await apiClient.get("/sisi/cart");
    return res.data;
  } catch (error) {
    console.log("faild to fetch: ", error)
    throw error
  }
};

export const addItemToCart = async (payload) => {
   try {
    const res = await apiClient.post("/sisi/cart/add", payload);
    return res.data;
  } catch (error) {
    console.log("faild to add: ", error)
    throw error
  }
};

export const updateCartQuantity = async (payload) => {
  try {
    const res = await apiClient.put("/sisi/cart/quantity", payload);
    return res.data;
  } catch (error) {
    console.log("faild to update: ", error)
    throw error
  }
};

export const removeCartItem = async (payload) => {
  try {
    const res = await apiClient.delete("/sisi/cart/remove", { data: payload });
    return res.data;
  } catch (error) {
    console.log("faild to remove: ", error)
    throw error
  }
};


export const createCategory = async (data) => {
  try {
  const res = await apiClient.post("/sisi/category", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to create:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getCategories = async () => {
  try {
  const res = await apiClient.get("/sisi/category");
  return res.data;
} catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getCategory = async (id) => {
  try {
  const res = await apiClient.get(`/sisi/category/${id}`);
  return res.data;
} catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateCategory = async (id, data) => {
  try {
  const res = await apiClient.put(`/sisi/category/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
} catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteCategory = async (id) => {
  try {
  const res = await apiClient.delete(`/sisi/category/${id}`);
  return res.data;
} catch (error) {
    console.log(
      "Failed to delete:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createProduct = async (data) => {
  try {
    const res = await apiClient.post("/sisi/product/add", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.log(
      "Product creation failed:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getProducts = async () => {
  try {
    const res = await apiClient.get("/sisi/products");
    return res.data;
  } catch (error) {
    console.log(
      "failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateProduct = async (id, data) => {
  try {
    const res = await apiClient.put(`/sisi/product/update/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteProduct = async (id) => {
  try {
    const res = await apiClient.delete(`/sisi/products/${id}`);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to delete:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const createBanner = async (formData) => {
  try {
    const res = await apiClient.post("/sisi/banner", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (err) {
    console.log("Create banner error:", err);
    throw err;
  }
};

export const getBanners = async () => {
  try {
    const res = await apiClient.get("/sisi/banner");
    return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const deleteBanner = async (id) => {
  try {
    const res = await apiClient.delete(`/sisi/banner/${id}`);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to delete:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateBanner = async(id, data) => {
   try {
    const res = await apiClient.put(`/sisi/banner/${id}`, data);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export const getOrders = async () => {
  try {
    const res = await apiClient.get("/sisi/orders");
    return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export const updateOrderStatus = async(id, data) => {
  try {
    const res = await apiClient.put(`/sisi/order/${id}`, data);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to update:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export const deleteOrder = async(id) => {
  try {
    const res = await apiClient.delete(`/sisi/order/${id}`);
    return res.data
  } catch (error) {
    console.log(
      "Failed to delete:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export const placeOrder = async (payload) => {
  try {
    const res = await apiClient.post("/sisi/order/place", payload);
    return res.data;
  } catch (error) {
    console.log("faild to place: ", 
      error.response?.data || error.message
    )
    throw error
  }
};

export const verifyPaymentApi = async (reference) => {
  try {
    const res = await apiClient.get(`/sisi/payment/paystack/verify?reference=${reference}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch order:", error.response?.data || error.message);
    throw error;
  }
};